export default __webpack_public_path__ + "static/media/track_record.456898c9.svg";